// libs
import { keyframes, css } from '@emotion/core';
import { styled } from '@nykaa/ui-components';

// components
import RippleIt from 'shared/components/RippleIt';

// styles
import { COLORS, MWEB_HEADER_ZINDEX } from 'shared/styles/base';
import { fixedBottomCss } from 'styles/mixin/core';

// constants
import { BOTTOM_NAV_COLORS, BOTTOM_NAV_HEIGHT } from './constants';

const slideUp = keyframes`
    from {
        transform: translateX(0) translateY(150%);
    }

    to {
        transform: translateX(0) translateY(0px);
    }
`;

export const Container = styled.div`
  position: fixed;
  bottom: 0;
  height: ${BOTTOM_NAV_HEIGHT}px;
  width: 100%;
  background-color: #fff;
  display: flex;
  border-top: 1px solid ${COLORS.BLACK_16};
  animation: ${slideUp} 0.35s ease forwards;
  z-index: ${MWEB_HEADER_ZINDEX};
  animation: ${slideUp} 0.35s ease forwards;
  ${({ theme }) => theme.typography.bodyMedium};
  ${fixedBottomCss(BOTTOM_NAV_HEIGHT)};
`;

export const BottomNavItem = styled(RippleIt)<{
  statesCount: number;
  isSelected: boolean;
}>`
  display: flex;
  align-items: center;
  width: ${(props) => `${100 / props.statesCount}%`};
  color: ${(props) =>
    props.isSelected ? BOTTOM_NAV_COLORS.SELECTED_STATE : BOTTOM_NAV_COLORS.DEFAULT_STATE};
  flex-flow: column;
`;

export const IconContainer = styled.div`
  margin-top: 6px;
  width: 24px;
  height: 24px;
  top: 6px;
  font-size: 24px;
  overflow: hidden;

  & .Shop {
    opacity: 0.64;
  }
`;

export const Title = styled.p`
  margin: 0;
`;

export const Image = styled.img`
  height: 100%;
  width: 100%;
`;

export const containerCss = css`
  margin-bottom: 55px;
`;
